import React, { Component, useEffect, useState } from "react";
import { HashRouter, Route, Switch, Redirect, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "./App.scss";
import dayjs from "dayjs";
import jalaliday from "jalaliday";
// import 'antd/dist/antd.css';
// redux
import { useDispatch } from "react-redux";
import { lang_change, plant_id, logged_in } from "./Redux/actions";
// Pages
import {
  Rememmber,
  Native_Users_List,
  Users_List,
  Facts_list,
  Tickets,
  Ticket,
  Login,
  Page404,
  Page500,
  Register,
  Dashboard,
  AddFact,
  FactSystemPage,
  AdminDashboard,
  Setting,
  Users,
  ByPanel,
  Analyse,
  EventsPage,
  ChoiceFactIndex,
  FactUser,
  ComparePanels,
} from "./Pages/index";
import { ToastContainer } from "react-toastify";
import Cookies from "js-cookie";
import NewTicketPage from "./Pages/Tickets/NewTicket";
import { Notifications } from "react-push-notification";
import EditFactPage from "./Pages/Edit_Fact";

const loading = () => (
  <div className="animated fadeIn pt-3 text-center loader">
    <div className="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
);
//ChoiceFactLayout
const ChoiceFactLayout = React.lazy(() =>
  import("./Containers/DefaultLayout/ChoiceFactPage")
);

// Containers
const DefaultLayout = React.lazy(() =>
  import("./Containers/DefaultLayout/DefaultLayout")
);
const DefaultLayoutAdmin = React.lazy(() =>
  import("./Containers/DefaultLayout/AdminLayout/DefaultLayoutAdmin")
);

const App = () => {
  // const tickets_id = useSelector((state) => state.tickets_id);
  const facts_id = useSelector((state) => state.facts_id);
  const authState = useSelector((state) => state.authState);
  const facts_id2 = JSON.parse(window.localStorage.getItem("f_i_v"));
  const [loadTime, setLoadTime] = useState(true);

  // console.log(authState , "is authState")
  const renderFactID = (routerProps, child) => {
    // console.log("i am in the rendefactid")
    let factID = parseInt(routerProps.match.params.id);
    dispatch(plant_id(parseInt(routerProps.match.params.id)));
    let foundFact = facts_id?.find((fact) => fact === factID);
    let foundFact2 = facts_id2?.find((fact) => fact === factID);
    //  console.log(authState , "is authState")
    return foundFact ? (
      <DefaultLayout {...routerProps}>{child}</DefaultLayout>
    ) : foundFact2 ? (
      <DefaultLayout {...routerProps}>{child}</DefaultLayout>
    ) : !authState ? (
      <Redirect to={`/`} />
    ) : (
      <Page404 {...routerProps} />
    );
  };

  // Automatic Main Language Change from history of the user :
  const dispatch = useDispatch();
  const lang = window.localStorage.getItem("lang");
  const [changeLang, setChangeLang] = useState(true);
  useEffect(() => {
    if (window.document.documentElement.lang === "fa") {
      console.log(lang , "is lang")
      
      dayjs.extend(jalaliday);
      dayjs.calendar("jalali");
    } else {
      console.log(lang , "is lang")
      dayjs.calendar("gregory");
    }
    const checkedLoggedIn = async () => {
      if (Cookies.get("token") && window.localStorage.getItem("m_t_s")) {
        // console.log("check")
        dispatch(logged_in(true));
        setLoadTime(false);
      } else {
        dispatch(logged_in(false));
        setLoadTime(false);
      }
    };
    const DetectLang = () => {
      if (changeLang === true) {
        if (lang && lang !== null && lang !== undefined) {
          // console.log("in the lang first");
          switch (lang) {
            case "persian":
              return dispatch(lang_change(1));
            case "english":
              return dispatch(lang_change(2));
          }
          setChangeLang(false);
        } else {
          window.localStorage.setItem("lang", "persian");
        }
      }
    };
    checkedLoggedIn();
    DetectLang();
  },[window.document.documentElement.lang]);
  // ////////////////////////////

  if (loadTime) return loading();
  else {
    try {
      return (
        <HashRouter>
          <React.Suspense fallback={loading()}>
            <ToastContainer rtl={true} />
            {/* <Notifications /> */}
            <Switch>
              {/* Auth Components */}

              <Route
                exact
                path="/"
                name="Login Page"
                render={(props) =>
                  authState ? (
                    <Redirect to="/choice_fact" />
                  ) : (
                    <Redirect to="/login" />
                  )
                }
              />
              <Route
                exact
                path="/login"
                name="Login Page"
                render={(props) => <Login {...props} />}
              />
              <Route
                exact
                path="/remmember"
                name="Remmember Password"
                component={Rememmber}
              />
              <Route
                exact
                path="/register"
                name="Register Page"
                render={(props) => <Register {...props} />}
              />
              <Route
                exact
                path="/404"
                name="Page 404"
                render={(props) => <Page404 {...props} />}
              />
              <Route
                exact
                path="/500"
                name="Page 500"
                render={(props) => <Page500 {...props} />}
              />

              {/* In Fact Components : */}
              <Route
                path="/:id/dashboard"
                name="Home"
                render={(props) =>
                  renderFactID(props, <Dashboard {...props} />)
                }
              />
              <Route
                path="/:id/panel"
                name="By Panel"
                render={(props) =>
                  renderFactID(
                    props,
                    <ByPanel plantId={parseInt(props.match.params.id)} />
                  )
                }
              />
              <Route
                path="/:id/events"
                name="Alert Page"
                render={(props) => renderFactID(props, <EventsPage />)}
              />
              <Route
                exact
                path="/:id/add_system"
                name="Adding Systems"
                render={(props) =>
                  renderFactID(
                    props,
                    <FactSystemPage
                      plant_id={parseInt(props.match.params.id)}
                    />
                  )
                }
              />
              <Route
                exact
                path="/:id/fact_user"
                name="Fact User"
                render={(props) => renderFactID(props, <FactUser />)}
              />
              <Route
                exact
                path="/:id/compare_panel"
                name="Fact User"
                render={(props) => renderFactID(props, <ComparePanels />)}
              />
              <Route
                path="/:id/setting"
                name="Setting"
                render={(props) => renderFactID(props, <Setting />)}
              />
              <Route
                path="/:id/Analysis"
                name="Analize Page"
                render={(props) => renderFactID(props, <Analyse />)}
              />

              {/* In Choice Fact Components : */}
              <Route
                exact
                path="/tickets"
                name="Tickets"
                render={(props) => (
                  <ChoiceFactLayout {...props}>
                    <Tickets />
                  </ChoiceFactLayout>
                )}
              />
              <Route
                path="/:id/tickets"
                render={() => <Redirect to="/tickets" />}
              />
              <Route
                path="/ticket/create"
                name="Create Ticket Page"
                render={(props) => (
                  <ChoiceFactLayout {...props}>
                    <NewTicketPage {...props} />
                  </ChoiceFactLayout>
                )}
              />
              <Route
                path="/tickets/:ticketId"
                name="Ticket Page"
                render={(props) => (
                  <ChoiceFactLayout {...props}>
                    <Ticket {...props} />
                  </ChoiceFactLayout>
                )}
              />
              <Route
                exact
                path="/add_fact"
                name="Adding Factory"
                render={(props) => (
                  <ChoiceFactLayout {...props}>
                    <AddFact />
                  </ChoiceFactLayout>
                )}
              />
              <Route
                exact
                path="/choice_fact"
                name="Landing Page"
                render={(props) => (
                  <ChoiceFactLayout {...props}>
                    <ChoiceFactIndex />
                  </ChoiceFactLayout>
                )}
              />
              <Route
                path="/:id/choice_fact"
                render={() => <Redirect to="/choice_fact" />}
              />
              <Route
                exact
                path="/user"
                name="User Panel"
                render={(props) => (
                  <ChoiceFactLayout {...props}>
                    <Users />
                  </ChoiceFactLayout>
                )}
              />
              <Route
                exact
                path="/:id/edit_fact"
                name="EditPlant"
                render={(props) => renderFactID(props, <EditFactPage />)}
              />

              {/* Admin Components */}
              <Route
                path="/admin_panel"
                name="Admin Dashboard"
                render={(props) => (
                  <DefaultLayoutAdmin {...props}>
                    <AdminDashboard />
                  </DefaultLayoutAdmin>
                )}
              />
              <Route
                path="/facts_list"
                name="Facts List"
                render={(props) => (
                  <DefaultLayoutAdmin {...props}>
                    <Facts_list />
                  </DefaultLayoutAdmin>
                )}
              />
              <Route
                path="/users_list"
                name="Users List"
                render={(props) => (
                  <DefaultLayoutAdmin {...props}>
                    <Users_List />
                  </DefaultLayoutAdmin>
                )}
              />
              <Route
                path="/native_users_list"
                name="ٌWebsite Users List"
                render={(props) => (
                  <DefaultLayoutAdmin {...props}>
                    <Native_Users_List />
                  </DefaultLayoutAdmin>
                )}
              />

              <Redirect to="/404" name="Not Found" />
            </Switch>
          </React.Suspense>
        </HashRouter>
      );
    } catch (error) {
      if (error) {
        console.log(error, "is error");
        Cookies.remove("token");
        window.localStorage.clear();
      }
    }
  }
};

export default App;
